import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, concatMap, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

import * as NewsActions from '../actions/news.actions';
import { NewsDetails } from '@fc-core/models/news-details.model';
import { NewsService } from '@fc-core/services/news.service';
import { getStoredNewsIds } from '@fc-core/services/news-storage.utils';

@Injectable()
export class NewsEffects {
  constructor(
    private actions$: Actions,
    private newsServiceService: NewsService,
  ) {}

  loadNews$ = createEffect(() =>
    this.actions$.pipe(
      ofType(NewsActions.loadNews),
      concatMap(() =>
        this.newsServiceService.getNews().pipe(
          switchMap((data: NewsDetails[]) => {
            return [
              NewsActions.loadNewsSuccess({ data }),
              NewsActions.setShowNews({ showNewsState: this.haveNews(data) }),
            ];
          }),
          catchError((error) => of(NewsActions.loadNewsFailure({ error }))),
        ),
      ),
    ),
  );

  haveNews(news: NewsDetails[]): number {
    if (!news?.length) {
      return 0;
    }

    const seenNewsIds = getStoredNewsIds();

    if (!seenNewsIds.length) {
      return news.length;
    }

    return news.filter((item) => !seenNewsIds.includes(item.id)).length;
  }
}
